<template>
  <div class="goback">
    <i class="el-icon-arrow-left" :style="iconStyle" @click="goback()"></i>
    <span v-if="isPC" :style="textStyle" @click="goback()">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "Goback",
  props: {
    isPC: {
      type: Boolean,
      default: true
    },
    iconStyle: {
      type: String,
      default: "color: #008077"
    },
    textStyle: {
      type: String,
      default: 'color: #767676'
    },

    text: {
      type: String,
      default: '返回上一页'
    }
  },
  data() {
    return {};
  },
  methods: {
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.el-icon-arrow-left {
  font-weight: bold;
}

.goback {
  display: flex;
  align-items: center;
  color: #008077;
  font-size: 16px;
  line-height: 1;
  text-align: left;
  & > * {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goback/index.vue